import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IMAGES } from '../../lib/images';

const services = [
  { id: '01', title: 'Guest Welcome', desc: 'First impressions matter. Authentic, warm, and grand welcoming rituals for your guests.', img: IMAGES.services.welcome },
  { id: '02', title: 'On-ground Management', desc: 'Invisible yet omnipresent team ensuring every micro-detail goes according to plan.', img: IMAGES.services.management },
  { id: '03', title: 'F&B Coordination', desc: 'Seamless culinary experiences, menu curation, and service management.', img: IMAGES.services.catering },
  { id: '04', title: 'Rituals Setup', desc: 'Precise arrangement and timing for all cultural and traditional ceremonies.', img: IMAGES.services.rituals },
  { id: '05', title: 'Logistics & RSVP', desc: 'End-to-end guest movement, 95% accuracy in RSVPs, and smooth check-ins.', img: IMAGES.portfolio[0] },
];

export const Services = () => {
  const [activeService, setActiveService] = useState(0);

  return (
    <section id="services" className="py-32 px-6 md:px-12 bg-primary text-primary-foreground min-h-screen flex flex-col justify-center">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-xs uppercase tracking-[0.3em] text-accent mb-16 font-medium">Chapter 02 — Our Expertise</div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <div className="flex flex-col justify-center w-full">
            {services.map((service, index) => (
              <div 
                key={service.id}
                className="group border-b border-white/10 py-8 cursor-pointer"
                onMouseEnter={() => setActiveService(index)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-baseline gap-6">
                    <span className="text-sm font-light text-accent/60">{service.id}</span>
                    <h3 className={`text-3xl md:text-5xl font-editorial transition-all duration-500 ${activeService === index ? 'text-white translate-x-4' : 'text-white/40'}`}>
                      {service.title}
                    </h3>
                  </div>
                  <motion.div 
                    initial={{ opacity: 0, rotate: -45 }}
                    animate={{ opacity: activeService === index ? 1 : 0, rotate: activeService === index ? 0 : -45 }}
                    className="text-accent"
                  >
                    ↗
                  </motion.div>
                </div>
                <AnimatePresence>
                  {activeService === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden"
                    >
                      <p className="pl-12 pt-6 text-white/60 font-light max-w-md text-lg">
                        {service.desc}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>

          <div className="hidden lg:block relative h-[700px] w-full overflow-hidden bg-white/5">
            <AnimatePresence mode="wait">
              <motion.img
                key={activeService}
                src={services[activeService].img}
                alt={services[activeService].title}
                initial={{ opacity: 0, scale: 1.1 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};
